import React from 'react';

import {
  Box,
  styled
} from '@mui/material';
import flightPath from 'assets/images/flight_path.svg';
import _ from 'lodash';
import {
  baseTypes,
  DownloadableResourceBox,
  legalDocumentsDataService
} from 'modules';



const RelativeBox = styled(Box)({
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  width: '100%'
});



interface IProps {
  apiFileData: baseTypes.IApiFileData[]
}

export const FC: React.FC<IProps> = props => {
  const getApiFileData = React.useCallback((title: legalDocumentsDataService.ProFormaTable) => {
    return _.find(props.apiFileData, data => data.title === title);
  }, [props.apiFileData]);



  return (
    <RelativeBox>
      <Box
        component='img'
        position='absolute'
        maxWidth='100%'
        zIndex={-1}
        src={flightPath}>
      </Box>

      <DownloadableResourceBox.FC
        title="Pro Forma Cap Table + Exit Waterfall Excel Document"
        thumbnailFilename="legal_pro_forma_waterfall_image_draft.png"
        apiFileData={getApiFileData('Pro Forma')}
        maxWidth={532}
        height={320}
        layoutVariant="proForma"
      />
    </RelativeBox>
  );
};
